export default __webpack_public_path__ + "static/media/slidingbefore.3a4016dc.jpg";